export default function CardsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.98431 4.9829L8.01245 4.81264C8.10253 4.26775 8.61727 3.89905 9.16216 3.98913L10.7051 4.24419L7.98431 10.0002L7.98431 4.9829ZM17.6682 9.50089L14.2712 16.6836L10.2706 14.7916L13.6676 7.60883L17.6682 9.50089ZM19.4273 8.12043C19.9266 8.35656 20.1399 8.95271 19.9038 9.45197L15.6516 18.4427C15.4155 18.942 14.8194 19.1553 14.3201 18.9192L8.51152 16.172C8.01225 15.9359 7.79894 15.3398 8.03506 14.8405L12.2872 5.84975C12.5233 5.35049 13.1195 5.13717 13.6187 5.3733L19.4273 8.12043ZM3.78916 7.58939L5.95534 15.3247L5.99288 5.93379L4.48245 6.35677C3.95062 6.5057 3.64022 7.05756 3.78916 7.58939Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
